import { loadScript } from '@rambler-id/dom';
let oneTapLoaded;
let oneTapPromise;
export const loadOneTap = async () => {
    if (oneTapLoaded)
        return;
    if (oneTapPromise)
        return oneTapPromise;
    oneTapPromise = loadScript('https://accounts.google.com/gsi/client');
    return oneTapPromise;
};
